<template>
  <div id="manage">
    <div class="content">
        <div class="title">分成结算</div>
        <div class="top">
            <div class="fl_left">
                <div class="wzbarBox">
                    <div class="wzbar" v-for="(name,index) in items" @click="tab(index,name)" :class="{'wzbars':index==num}">
                        <div>{{name.name}}</div>
                        <span></span>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <el-date-picker
                          style="width:400px"
                          v-model="dateList"
                          :clearable="true"
                          type="daterange"
                          @change="getFinanceList()"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker>
                        <el-select v-model="company_id" clearable filterable placeholder="请选择承办单位" @change="getFinanceList()">
                            <el-option
                            v-for="item in companyList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">

                    <Table :columns="financeColumns" :data="financeList" :loading="loading"></Table>
                    <Page :page-size="pageSize" :total="total" show-total :current="pageNum" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
                </div>
            </div>
        </div>
    </div>
    <!-- 财务明细 -->
    <el-dialog
        v-if="showShare"
        title="查看分成"
        :visible.sync="showShare"
        width="50%">
        <order-share :order_id="order_id" :order_money="order_money"></order-share>
    </el-dialog>
  </div>
</template>

<script>
    import OrderShare from './OrderShare.vue';
    export default {
        components: { OrderShare},
        name: 'manage',
        data () {
            return {
                showShare:false,
                order_id:'',
                order_money:'',
                dialogTableVisible:false,
                dateList:['',''],
                num:0,
                tabId:1,
                items:[
                    {
                        name:'待结算',
                        type:1
                    },
                    {
                        name:'已冻结',
                        type:2
                    },
                    {
                        name:'已结算',
                        type:10
                    },
                ],
                financeColumns: [
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width:80
                    },
                    {
                        title: '承办单位',
                        align: 'center',
                        key: 'name'
                    },
                    {
                        title: '订单总金额',
                        align: 'center',
                        key: 'income',
                    },
                    {
                        title: '分成占比(%)',
                        align: 'center',
                        key: 'share_scale',
                    },
                    {
                        title: '承办单位收入(元)',
                        align: 'center',
                        key: 'share_income',
                    },
                    {
                        title: '收入时间',
                        align: 'center',
                        key: 'created_at',
                    },
                    {
                        title: '状态',
                        align: 'center',
                        key: 'status',
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('div',{
                                    style:{
                                        color:'#ff7f50',
                                    }
                                },'正常待结算');
                            }
                            else if(params.row.status==2){
                                return h('div',{
                                    style:{
                                        color:'#cccccc',
                                    }
                                },'冻结中');
                            }
                            else if(params.row.status==10){
                                return h('div',{
                                    style:{
                                        color:'#49c00e',
                                    }
                                },'已结算');
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        render: (h, params) => {
                            let _action = new Array();
                            _action.push(h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor:'rgba(0,0,0,0)',
                                        border:'none',
                                    },
                                    on: {
                                        click: () => {
                                            let _this=this;
                                            _this.order_id      = params.row.order_id;
                                            _this.order_money   = params.row.income;
                                            _this.showShare=true;
                                        }
                                    }
                                },'查看明细'));
                            if(params.row.status==2){
                                _action.push(h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor:'rgba(0,0,0,0)',
                                        border:'none',
                                        margin:'0 5px',
                                    },
                                    on: {
                                        click: () => {
                                            let _this=this;
                                            _this.order_sharing_ids     = [];
                                            _this.order_sharing_ids.push(params.row.order_sharing_id);
                                            _this.order_sharing_status  = 1;
                                            _this.order_sharing_text  = "确认取消冻结吗？";
                                            _this.confirmOrder();
                                        }
                                    }
                                },"取消冻结"));
                            }else if(params.row.status==1){
                                _action.push(h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor:'rgba(0,0,0,0)',
                                        border:'none',
                                        margin:'0 5px',
                                    },
                                    on: {
                                        click: () => {
                                            let _this=this;
                                            _this.order_sharing_ids     = [];
                                            _this.order_sharing_ids.push(params.row.order_sharing_id);
                                            _this.order_sharing_status  = 10;
                                            _this.order_sharing_text  = "确认结算吗？";
                                            _this.confirmOrder();
                                        }
                                    }
                                },"确认结算"));

                                _action.push(h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor:'rgba(0,0,0,0)',
                                        border:'none',
                                        margin:'0 5px',
                                    },
                                    on: {
                                        click: () => {
                                            let _this=this;
                                            _this.order_sharing_ids     = [];
                                            _this.order_sharing_ids.push(params.row.order_sharing_id);
                                            _this.order_sharing_status  = 2;
                                            _this.order_sharing_text  = "确认冻结本笔收入？";
                                            _this.confirmOrder();
                                        }
                                    }
                                },"冻结"));
                            }
                            return h('div', _action);
                        }
                    }
                ],
                total:null,
                pageNum:1,
                pageSize:10,
                loading:false,
                financeList: [],//结算列表
                companyList:[],//承办单位列表
                company_id:'',//承办单位ID 搜索用
                current_company_id:'',//当前承办单位ID 点击使用 
                company_name:'',//当前承办单位 点击使用 
                incomeList:[], //收益列表页码
                incomePageNum:1, //收益列表页码
                incomePageSize:10, //收益列表每页数量
                incomePageTotal:null, //收益列表总数
                batch_id:'',//结算批次
                order_sharing_ids:[],//设置
                order_sharing_status:'',//设置
                order_sharing_text:'',//设置
            }
        },
        methods:{
            tab(index,item){
                let _this=this;
                _this.num=index;
                _this.tabId=item.type;
                _this.getFinanceList();
            },
            //获取收益列表
            getIncomeList(){
                let _this=this;
                _this.$axios.post('getconfirmorderlist',{
                    company_id:_this.current_company_id,
                    page:_this.incomePageNum,
                    start_date:_this.dateList[0],
                    end_date:_this.dateList[1],
                    batch_id:_this.batch_id,
                }).then(res=>{
                    if(res.data.code==200){
                        _this.incomePageTotal = res.data.data.total;
                        _this.incomeList    = res.data.data.list;
                    }else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //更新收益
            updateIncomePage(num=1) {
                let _this=this;
                _this.incomePageNum = num;
                if(_this.dateList == null ){
                    _this.dateList = ['',''];
                }
                _this.getIncomeList();
            },
            //获取结算数据列表
            getFinanceList(index){
                let _this=this;
                if(index==1){
                    _this.pageNum=1;
                }
                let _url = 'getunconfirmcompanylist';
               
                _this.$axios.post(_url,{
                    status:_this.tabId,
                    company_id:_this.company_id,
                    page:_this.pageNum,
                    start_date:_this.dateList[0],
                    end_date:_this.dateList[1],
                }).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.financeList=res.data.data.list;
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            //获取承办单位列表
            getCompanyList(){
                let _this=this;
                _this.$axios.post('getcompanyselect',{
                    type:1
                }).then(res=>{
                    if(res.data.code==200){
                        _this.companyList=res.data.data;
                    }else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //确认结算
            confirmOrder(){
                let _this=this;
                this.$Modal.confirm({
                    title: '提示',
                    content: _this.order_sharing_text,
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        _this.$axios.post('setsharestatus',{
                                order_sharing_ids:_this.order_sharing_ids,
                                status:_this.order_sharing_status
                            }).then(res=>{
                            if(res.data.code==200){
                                _this.$Message.info("操作成功");
                                _this.updatePage(0)
                            }else{
                                _this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                            console.log(error);
                        });
                    },
                    onCancel: () => {
                        // this.$Message.info('取消');
                    }
                });
                
            },
            updatePage(num) {
                let _this=this;
                _this.pageNum = num;
                _this.getFinanceList(0);
            },
        },
        created(){
            let _this=this; 
            _this.getCompanyList();
            _this.getFinanceList(0);
        }
    }
</script>

<style scoped>
/**/
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 61px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 62px;
        line-height: 62px;
        border-bottom: 1px solid #e6e6e6;
        /*padding: 0 20px;*/
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }

    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/finance/finance.vue